import {Component, Input} from '@angular/core';
import {TipoRisorsa} from '../../../_models/generated/tipo-risorsa'
import {TIPO_RISORSA_UI} from "../../../_helpers/TipoRisorsa";

@Component({
  selector: 'app-risorsa-tipo-label',
  templateUrl: './risorsa-tipo-label.component.html',
  styleUrls: ['./risorsa-tipo-label.component.scss'],
  standalone: false
})
export class RisorsaTipoLabelComponent {
  @Input() risorsaTipo: TipoRisorsa = TipoRisorsa.TUTTO;
  protected readonly TipoRisorsa = TipoRisorsa
  protected readonly TIPO_RISORSA_UI = TIPO_RISORSA_UI;
}
